import type { ClientOfferViewUnit } from '@ooh/contracts';

/**
 * Builds a lookup of enriched unit by snapshot row id for O(1) access. Shared by
 * client-offer-page.tsx (SSO, both the interactive and read-only content) and
 * public-offer-page.tsx (public link).
 */
export function buildEnrichedUnitById(
  units: ClientOfferViewUnit[],
): Map<number, ClientOfferViewUnit> {
  return new Map(units.map((unit) => [unit.id, unit]));
}
